import { sendGameEventBeaconAction } from '@/redux/action/gameAnalytics';
import { getUserUuid } from '@/util/uuid';
import { useAppSelector } from './redux';

const useAnalytics = () => {
  const { game } = useAppSelector(state => state.game);
  const onCreateAnalytics = async (type: string) => {
    const payload = {
      type,
      game: game?._id || '',
      uid: await getUserUuid(),
    };
    sendGameEventBeaconAction(payload);
  };
  return { onCreateAnalytics };
};

export { useAnalytics };
